import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { coerceBoolean } from 'coerce-property';

export interface DotClickEvent {
  index: number;
  event: MouseEvent;
}

@Component({
  selector: 'zelis-dots',
  templateUrl: './dots.component.html',
  styleUrls: ['./dots.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotsComponent {
  @HostBinding() class = 'zelis-dls';

  @Input() count!: number;
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';
  @Input() selectedIndex = 0;
  @Input() @coerceBoolean interactive = true;
  @Input() @coerceBoolean dark = false;

  @Output() dotClicked = new EventEmitter<DotClickEvent>();

  get isHorizontal() {
    return this.orientation === 'horizontal';
  }

  get isVertical() {
    return this.orientation === 'vertical';
  }

  get isDisabled() {
    return !this.interactive;
  }

  isSelected(index: number) {
    return this.selectedIndex === index;
  }

  handleClick(event: MouseEvent, index: number) {
    this.selectedIndex = index;
    this.dotClicked.emit({
      event,
      index,
    });
  }
}
